import { useQuery } from 'react-query';
import { PecaAiOrderDetailRequest } from './orders.types';
import ordersServices from './orders.services';
import notificationError from '@/utils/functions/notificationError';

export const QUERY_PECAAI_ORDER_DETAIL = 'peca-ai/order/detail';

export function usePecaAiOrderDetail(
  params: PecaAiOrderDetailRequest,
  enabled = true,
) {
  return useQuery({
    queryKey: [QUERY_PECAAI_ORDER_DETAIL, { ...params }],
    queryFn: () => ordersServices.orderDetail(params),
    onError: notificationError,
    enabled,
  });
}
